import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import { BaseOntarioObstetricalFileSubSection, BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";

class OntarioObstetricalFilePrenatalGeneticInvestigations extends BaseOntarioObstetricalFileSubSection<BaseOntarioObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        const prenatalGenetic = this.props.form.Opr2.PrenatalGeneticInvestigations;

        return (
            <div className="section border border-top pregnancysummary prenatal-genetic-min-height">
                {this.renderSubTitle("ObstetricalFile_PrenatalGeneticInvestigationsLabel")}
                <div className="row">
                    <div className="col-md-3 flex-display flex-start flex-align-items-center">
                        <span className="margin-sm-right text-bold">{this.getString("ObstetricalFile_ScreeningOfferedLabel")}</span>
                        {this.controlRenderer.renderInlineYesNoRadio(
                            prenatalGenetic.IsScreeningOffered,
                            value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.PrenatalGeneticInvestigations.IsScreeningOffered = value),
                            "PrenatalGenetic_IsScreeningOffered",
                            "radio-btn-min-height margin-right-15px"
                        )}
                    </div>
                </div>
                <div className="row padding-xl-top">
                    <div className="col-md-3 padding-xl-top">
                        {this.controlRenderer.renderCheckbox(
                            "ObstetricalFile_FirstTrimesterCombinedScreeningAbbreviationLabel",
                            prenatalGenetic.FirstTrimesterCombinedScreening,
                            value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.PrenatalGeneticInvestigations.FirstTrimesterCombinedScreening = value),
                            "",
                            "text-bold"
                        )}
                    </div>
                    <div className="col-md-3">
                        <div className="row">
                            {this.controlRenderer.renderCheckbox(
                                "ObstetricalFile_IntegratedPrenatalScreening11To13WeeksLabel",
                                prenatalGenetic.IntegratedPrenatalScreening11To13Weeks,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.PrenatalGeneticInvestigations.IntegratedPrenatalScreening11To13Weeks = value),
                                "col-md-12",
                                "text-bold"
                            )}
                        </div>
                        <div className="row">
                            {this.controlRenderer.renderCheckbox(
                                "ObstetricalFile_IntegratedPrenatalScreening15To20WeeksLabel",
                                prenatalGenetic.IntegratedPrenatalScreening15To20Weeks,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.PrenatalGeneticInvestigations.IntegratedPrenatalScreening15To20Weeks = value),
                                "col-md-12",
                                "text-bold"
                            )}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="row">
                            {this.controlRenderer.renderCheckbox(
                                "ObstetricalFile_MaternalSerumScreeningLabel",
                                prenatalGenetic.IsMaternalSerumScreening,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.PrenatalGeneticInvestigations.IsMaternalSerumScreening = value),
                                "col-md-12",
                                "text-bold"
                            )}
                        </div>
                        <div className="row">
                            {this.controlRenderer.renderCheckbox(
                                "ObstetricalFile_AlphaFetoProteinLabel",
                                prenatalGenetic.AlphaFetoProtein,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.PrenatalGeneticInvestigations.AlphaFetoProtein = value),
                                "col-md-12",
                                "text-bold"
                            )}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="row">
                            <div className="col-md-12">
                                <span className="margin-sm-right text-bold">{this.getString("ObstetricalFile_CellFreeFetalLabel")}</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 flex-display flex-start flex-align-items-center">
                                <span className="margin-sm-right text-bold">{this.getString("OfferedLabel")}</span>
                                {this.controlRenderer.renderInlineYesNoRadio(
                                    prenatalGenetic.IsOfferedCellFreeDNA,
                                    value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.PrenatalGeneticInvestigations.IsOfferedCellFreeDNA = value),
                                    "PrenatalGenetic_IsOfferedCellFreeDNA",
                                    "radio-btn-min-height margin-md-right"
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        {this.controlRenderer.renderTextboxWithPositiveNegativeOption({
                            value: prenatalGenetic.FirstTrimesterCombinedScreeningResult,
                            onChange: value => this.props.mutateModelState(s => s.Opr2.PrenatalGeneticInvestigations.FirstTrimesterCombinedScreeningResult = value),
                            maxLength: 16
                        })}
                    </div>
                    <div className="col-md-3">
                        {this.controlRenderer.renderTextboxWithPositiveNegativeOption({
                            value: prenatalGenetic.IntegratedPrenatalScreeningResult,
                            onChange: value => this.props.mutateModelState(s => s.Opr2.PrenatalGeneticInvestigations.IntegratedPrenatalScreeningResult = value),
                            maxLength: 16
                        })}
                    </div>
                    <div className="col-md-3">
                        {this.controlRenderer.renderTextboxWithPositiveNegativeOption({
                            value: prenatalGenetic.MaternalSerumScreeningAndAlphaFetoProteinResult,
                            onChange: value => this.props.mutateModelState(s => s.Opr2.PrenatalGeneticInvestigations.MaternalSerumScreeningAndAlphaFetoProteinResult = value),
                            maxLength: 16
                        })}
                    </div>
                    <div className="col-md-3">
                        {this.controlRenderer.renderAutoCompleteTextbox({
                            value: prenatalGenetic.CellFreeDNAResult,
                            autoCompleteItems: [
                                new SearchableItemModelT(this.getString("LowRiskLabel"), "CellFreeDNA_LowRisk"),
                                new SearchableItemModelT(this.getString("HighRiskLabel"), "CellFreeDNA_HighRisk")
                            ],
                            onChange: value => this.props.mutateModelState(s => s.Opr2.PrenatalGeneticInvestigations.CellFreeDNAResult = value),
                            onAutoCompleteSelected: (code, _, value) => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.PrenatalGeneticInvestigations.CellFreeDNAResult = value),
                            maxLength: 16,
                            disableMatchAutoSorting: true
                        })}
                    </div>
                </div>
                <div className="row margin-sm-top">
                    <div className="col-md-3">
                        <div className="row">
                            <div className="col-md-12"><span className="margin-sm-right text-bold">{this.getString("ObstetricalFile_CVSAmnioLabel")}</span></div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 flex-display flex-start flex-align-items-center">
                                <span className="margin-sm-right text-bold">{this.getString("OfferedLabel")}</span>
                                {this.controlRenderer.renderInlineYesNoRadio(
                                    prenatalGenetic.IsOfferedChorionicVillusSampling,
                                    value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.PrenatalGeneticInvestigations.IsOfferedChorionicVillusSampling = value),
                                    "PrenatalGenetic_IsOfferedChorionicVillusSampling",
                                    "radio-btn-min-height margin-right-15px"
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="row">
                            <div className="col-md-12"><span className="margin-sm-right text-bold">{this.getString("ObstetricalFile_OtherGeneticTestingLabel")}</span></div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 flex-display flex-start flex-align-items-center">
                                <span className="margin-sm-right text-bold">{this.getString("OfferedLabel")}</span>
                                {this.controlRenderer.renderInlineYesNoRadio(
                                    prenatalGenetic.IsOfferedOtherGeneticTesting,
                                    value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.PrenatalGeneticInvestigations.IsOfferedOtherGeneticTesting = value),
                                    "PrenatalGenetic_IsOfferedOtherGeneticTesting",
                                    "radio-btn-min-height margin-right-15px"
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="row">
                            <div className="col-md-12"> <p className="text-bold">{this.getString("ObstetricalFile_NTRiskAssesmentLabel")}</p> </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12"><p className="text-bold">({this.getString("MultipleLabel")})</p></div>
                        </div>
                    </div>
                    <div className="col-md-3 padding-xl-top">
                        <p className="text-bold">{this.getString("ObstetricalFile_AbnormalPlacentalBiomarkersLabel")}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        {this.controlRenderer.renderTextboxWithPositiveNegativeOption({
                            value: prenatalGenetic.ChorionicVillusSamplingResult,
                            onChange: value => this.props.mutateModelState(s => s.Opr2.PrenatalGeneticInvestigations.ChorionicVillusSamplingResult = value),
                            maxLength: 16
                        })}
                    </div>
                    <div className="col-md-3">
                        {this.controlRenderer.renderTextboxWithPositiveNegativeOption({
                            value: prenatalGenetic.OtherGeneticTestingResult,
                            onChange: value => this.props.mutateModelState(s => s.Opr2.PrenatalGeneticInvestigations.OtherGeneticTestingResult = value),
                            maxLength: 16
                        })}
                    </div>
                    <div className="col-md-3">
                        {this.controlRenderer.renderTextboxWithPositiveNegativeOption({
                            value: prenatalGenetic.NuchalTranslucency,
                            onChange: value => this.props.mutateModelState(s => s.Opr2.PrenatalGeneticInvestigations.NuchalTranslucency = value),
                            maxLength: 16
                        })}
                    </div>
                    <div className="col-md-3">
                        {this.controlRenderer.renderTextboxWithPositiveNegativeOption({
                            value: prenatalGenetic.AbnormalPlacentalBiomarkers,
                            onChange: value => this.props.mutateModelState(s => s.Opr2.PrenatalGeneticInvestigations.AbnormalPlacentalBiomarkers = value),
                            maxLength: 16
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export { OntarioObstetricalFilePrenatalGeneticInvestigations };
